// extracted by mini-css-extract-plugin
export default {"wrap":"SearchInput_wrap__sy6fa","icon":"SearchInput_icon__tmX83","input":"SearchInput_input__sFxIH"};